export const checkActiveCollapse = (
    elementIds: string[] | undefined,
    id: string
) => {
    if (!elementIds) return false;

    return elementIds.some((elementId) => elementId === id);
};
